import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Action } from '../../actions';
import {
    clearImageSmartCenterEditor,
    fixSmartCenterImageHeight,
    saveImageSmartCenter,
    setImageSmartCenterPos,
    setSelectedImageSmartCenterRatio
} from '../../actions/imageSmartCenterEditor';
import {
    DispatchProps,
    ImageSmartCenterEditor,
    StateProps
} from '../../components/ImageSmartCenterEditor/ImageSmartCenterEditor';
import { State } from '../../typings/state';

const mapStateToProps = (state: State): StateProps => {
    const { data, imageHeight } = state.imageSmartCenterEditor;

    if (!data) {
        throw Error('no data');
    }

    const {
        imageUrl,
        centers,
        sortOrder,
        selectedId,
        imageSize,
        error,
        status
    } = data;

    return {
        imageUrl,
        centers,
        sortOrder,
        selectedId,
        imageSize,
        error,
        cropImageHeight: imageHeight,
        status
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>): DispatchProps => {
    return {
        onSave: () => {
            dispatch(saveImageSmartCenter());
        },
        onCancel: () => {
            dispatch(clearImageSmartCenterEditor());
        },
        onSelectFormat: selectedId => {
            dispatch(setSelectedImageSmartCenterRatio(selectedId));
        },
        onChangePosition: (selectedId: string, x: number, y: number) => {
            dispatch(setImageSmartCenterPos(x, y));
        },
        onImageLoad: (imageHeight: number, imageUrl: string) => {
            dispatch(fixSmartCenterImageHeight(imageHeight, imageUrl));
        }
    };
};

export const ImageSmartCenterEditorContainer = connect<
    StateProps,
    DispatchProps,
    {}
>(
    mapStateToProps,
    mapDispatchToProps
)(ImageSmartCenterEditor);
